<template>

  <div class="input-container" v-bind:class="{ disabled: disabled }">
    <input type="radio"
            :id="$t(`${step}.${type}.value`)"
            :class="`radio-button ${getCheckedState()}`"
            :name="`${step}`"
            :value="`${type}`"
            :disabled="disabled"
            v-on:change="updateInput"
            v-on:click="registerUserInput()" v-on:keyup="registerUserInput()"
    />
    <div class="radio-tile">
      <label :for="$t(`${step}.${type}.value`)" class="radio-tile-label" v-on:click="registerUserInput()" v-on:keyup="registerUserInput()">
        <div v-if="showIcon()" class="icon">

          <div v-if="availableWallProfile()" class="radio-tile-background-image" :style="`background-image: url(img/${step}/${type}.png)`">
          </div>

          <img v-else :src="getIconSrc()" :alt="$t(`${step}.${type}.title`)"/>
        </div>
        <p class="title" v-html="$t(`${step}.${type}.title`)"></p>
        <p v-html="$t(`${step}.${type}.elements`)"></p>
        <p v-html="$t(`${step}.${type}.infoText`)"></p>
      </label>
    </div>
    <div v-if="disabled" class="disabled-layer"></div>
  </div>
</template>

<script>
export default {
  name: 'StoRadio',
  props: {
    step: String,
    type: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checkedState: ''
    }
  },
  computed: {

  },
  methods: {
    registerUserInput: function (item) {
      // this line needs to track only User Input
      this.$root.$children['0'].userDidAction = true
    },
    updateInput: function (event) {
      let myValue = event.target.value
      if (myValue.indexOf('noNotch_') >= 0) {
        myValue = 'noNotch'
      } else if (myValue.indexOf('notch_') >= 0) {
        myValue = 'notch'
      }

      if (myValue.indexOf('novip_') >= 0) {
        myValue = 'novip'
      } else if (myValue.indexOf('vip_') >= 0) {
        myValue = 'vip'
      }

      if (myValue.indexOf('3') >= 0) {
        myValue = '3'
      } else if (myValue.indexOf('6') >= 0) {
        myValue = '6'
      } else if (myValue.indexOf('10') >= 0) {
        myValue = '10'
      }
      const payload = {
        key: this.step,
        value: myValue,
        validate: true
      }
      this.$store.dispatch('didInputFkt', payload)

      this.$store.commit('merchandiserViewStateIncreasement')
      this.tracking()
    },
    tracking: function () {
      let virtualPageURL = '/' + this.$tc(this.step + '.virtualPageURL')
      let virtualPageTitle = this.$tc(this.step + '.virtualPageTitle')
      const rootApp = this.$root && this.$root.$children && this.$root.$children['0']
      if (rootApp && rootApp.$refs && rootApp.$refs.mytab && typeof rootApp.$refs.mytab.getActiveTabIndex === 'function') {
        if (rootApp.$refs.mytab.getActiveTabIndex() === 10) {
          virtualPageURL = '/expertenansicht'
          virtualPageTitle = virtualPageURL = 'Expertenansicht'
        }
      }
      let gtmEvent = 'JKK-Events'
      let gtmEventCategory = this.$t(this.step + '.virtualPageTitle')
      let gtmEventAction = 'Radio'
      let gtmEventLabel = this.$t(this.step + '.' + this.type + '.title')
      if (this.type === 'epsAndPlaster') {
        gtmEventLabel = this.$t(this.step + '.' + this.type + '.titleGTM')
      }
      let gtmEventValue = ''
      if (rootApp && typeof rootApp.currentPage !== 'undefined' && typeof rootApp.globalGTMFkt === 'function') {
        if (this.step === 'elementForm') {
          gtmEventLabel = this.$t(this.step + '.' + this.type + '.pdfTitle')
          rootApp.globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, gtmEventValue, virtualPageURL, virtualPageTitle)
        } else {
          rootApp.globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, gtmEventValue, virtualPageURL, virtualPageTitle)
        }
      }
    },
    availableWallProfile: function () {
      if (this.step === 'wallProfiles') {
        if (this.type === 'uf_jaka' ||
            this.type === 't_jak' ||
            this.type === 't_jaka' ||
            this.type === 't_jakp' ||
            this.type === 'uf_jak' ||
            this.type === 'uf_jakp') {
          return true
        }
      }
      return false
    },
    showIcon: function () {
      if (this.step === 'dripEdgeProfile') {
        return false
      }

      return true
    },
    getIconSrc: function () {
      if (this.step === 'notches' && this.type === 'notch_jaka') {
        return 'img/notches/STO_JAK_Skizze_P25307-05_2026-01-27_260204-ohneEH.svg'
      }
      return `img/${this.step}/${this.type}.png`
    },

    getCheckedState: function () {
      if ((this.step === 'vacuumPanels') || (this.step === 'notches')) {
        if (this.type.indexOf('_')) {
          if (this.type.split('_')[0] === this.$store.state.calculatorData.currentOrder[this.step]) {
            return 'checked'
          }
        }
      } else if (this.type === this.$store.state.calculatorData.currentOrder[this.step]) {
        return 'checked'
      } else {
        return ''
      }
    }
  },
  mounted: function () {
    // console.log('--- StoRadio rendert ---')
    this.getCheckedState()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
